<template>
<div>
  <div class="main">
    <div class="plk-app" v-show="isApp">
      <!-- <div class="plk-app-logo">e普惠</div> -->
      <div class="plk-app-logo">
        <img src="../assets/img/144.png" alt="">
      </div>
      <div class="plk-app-title">
        <span>好兽药APP</span>
        <strong>应用商城</strong>
      </div>
      <div class="plk-app-right">
        <div class="plk-app-open">
          <div class="app-open">打开APP</div>
          <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
            <script type="text/wxtag-template">
              <style>.btn {height: 45px;}</style>
              <div class="btn">打开APP</div>
            </script>
          </wx-open-launch-app>
        </div>
        <!-- <div class="plk-app-open" @click="downloadapp">下载APP</div> -->
        <div class="plk-app-close" @click="closeApp">
          <img src="../assets/img/Delete@3x.png" alt="">
        </div>
      </div>
    </div>
    <div class="plk-app-height" v-show="isApp"></div>
    <div class="plk-img-swiper">
      <cube-slide :initial-index="1" :data="bannerList" ref="slide">
        <cube-slide-item v-for="(item, index) in bannerList" :key="index" @click.native="clickHandler(item, index)">
          <img :src="item">
        </cube-slide-item>
      </cube-slide>
    </div>
    <div class="plk-ordinary" v-if="itemType == '0'">
      <div class="ordinary-left">¥{{retailPrice | priceFloat}}</div>
      <div class="ordinary-right">成交量:{{salesTotal}}</div>
    </div>
    <div class="plk-seckill" v-if="itemType == '1'">
      <div class="seckill-img">
        <img src="../assets/img/xsms@2x.png" alt="">
      </div>
      <div class="seckill-left">
        <strong>¥{{preferentialPrice | priceFloat}}</strong>
        <div class="seckill-total">
          <span>¥{{retailPrice | priceFloat}}</span>
          <em>已售{{salesTotal}}件</em>
        </div>
      </div>
      <div class="seckill-right">
        <div class="seckill-text">距活动结束时间</div>
        <div class="seckill-time">{{activityEndTime}}</div>
      </div>
    </div>
    <div class="plk-limitBuy" v-if="itemType == '2'">
      <div class="limitBuy-img">
        <img src="../assets/img/ppsg@2x.png" alt="">
      </div>
      <div class="limitBuy-left">
        <strong>¥{{preferentialPrice | priceFloat}}</strong>
        <div class="limitBuy-total">
          <span>¥{{retailPrice | priceFloat}}</span>
          <em>已售{{salesTotal}}件</em>
        </div>
      </div>
      <div class="limitBuy-right">
        <div class="limitBuy-text">距活动结束时间</div>
        <div class="limitBuy-time">{{activityEndTime}}</div>
      </div>
    </div>
    <div class="plk-newgoods" v-if="itemType == '3'">
      <div class="newgoods-img">
        <img src="../assets/img/newgoods.png" alt="">
      </div>
      <div class="newgoods-left">
        <strong>¥{{preferentialPrice | priceFloat}}</strong>
        <span>¥{{retailPrice | priceFloat}}</span>
      </div>
      <div class="newgoods-right">已售{{salesTotal}}件</div>
    </div>
    <div class="plk-combination" v-if="itemType == '4'">
      <div class="combination-img">
        <img src="../assets/img/lmzh@2x.png" alt="">
      </div>
      <div class="combination-left">
        <strong>¥{{preferentialPrice | priceFloat}}</strong>
        <div class="combination-total">
          <span>¥{{retailPrice | priceFloat}}</span>
          <em>已售{{salesTotal}}件</em>
        </div>
      </div>
      <div class="combination-right">
        <div class="combination-text">距活动结束时间</div>
        <div class="combination-time">{{activityEndTime}}</div>
      </div>
    </div>
    <div class="plk-title" v-if="itemType == '4'">
      <div class="plk-goodsName">{{goodsName}}</div>
      <div class="plk-commonName">{{commonName}}</div>
    </div>
    <div class="plk-title" v-else>
      <div class="plk-goodsName">{{goodsName}}</div>
      <div class="plk-commonName">通用名称: {{commonName}}</div>
    </div>

    <div class="plk-goodslist" v-if="itemType == '4'">
      <div class="goodslist-title">套餐详情</div>
      <div class="goodslist">
        <cube-slide ref="slide" :data="goodsList1">
        <cube-slide-item v-for="(item, index) in goodsList1" :key="index">
          <div class="goodslist-box" v-for="(item1, index) in item" :key="index">
            <div class="goodslist-img">
              <img :src="item1.imageUrl" alt="">
            </div>
            <div class="goodslist-text">{{item1.goodsName}}</div>
            <div class="goodslist-pices">¥{{item1.goodsRetailPrice}}</div>
          </div>
        </cube-slide-item>
        </cube-slide>
      </div>
    </div>

    <div class="plk-back-top" v-if="itemType == '0' || itemType == '4'">
      <div class="plk-securities">
        <div class="plk-securities-left">领券</div>
        <div class="plk-securities-right">
          <div class="securities" v-for="(item, index) in psCouponBos" :key="index">满{{item.sccAmount}}减{{item.sccPreferentialValue}}</div>
        </div>
      </div>
    </div>

    <div class="plk-back">
      <div class="plk-statement">
        <div class="plk-zpbz">
          <img src="../assets/img/zp@2x.png" alt="">
          <span>正品保证</span>
        </div>
        <div class="plk-jyps">
          <img src="../assets/img/jyps@2x.png" alt="">
          <span>假一赔十</span>
        </div>
      </div>
    </div>
    <div class="plk-back-bottom" v-show="store">
      <div class="plk-store">
        <div class="store-logoImg">
          <img :src="logoImg" alt="">
        </div>
        <div class="store-text">
          <div class="store-name">{{stName}}</div>
          <div class="store-start">
            <div class="start" v-if="starClass == 1"><span>店铺星级</span>★☆☆☆☆</div>
            <div class="start" v-if="starClass == 2"><span>店铺星级</span>★★☆☆☆</div>
            <div class="start" v-if="starClass == 3"><span>店铺星级</span>★★★☆☆</div>
            <div class="start" v-if="starClass == 4"><span>店铺星级</span>★★★★☆</div>
            <div class="start" v-if="starClass == 5"><span>店铺星级</span>★★★★★</div>
          </div>
        </div>
      </div>
    </div>
    <div class="plk-detail">
      <div class="detail-title">商品详情</div>
      <div class="detail-img">
        <div v-for="(item, index) in detailList" :key="index">
          <img :src="item" alt="">
        </div>
      </div>
    </div>
    <div class="plk-height"></div>
    <div class="plk-buton">
      <div class="plk-float-buton" @click="downloadapp">下载APP</div>
    </div>
  </div>
</div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { iswx, result } from '@/utils/utils.js'
import { shopGeneral,shopLimitBuy,shopNewGoods,shopSeckill,shopCombination,shopEnable,wxShare } from '@/api/resetApi.js'

export default {
  name: 'detail',
  data() {
    return {
      isApp: true,
      store: true,
      itId: '',
      itemType: '',
      activityId: '',
      imgurl: '',
      desc: '我在好兽药上发现一个不错的商品，快来看看吧',
      bannerList: [],

      pageNum: 1,
      pageSize: 3,

      activityEndTime: '',
      retailPrice: '',
      preferentialPrice: '',
      salesTotal: '',
      goodsName: '',
      commonName: '',
      organId: '',

      stName: '',
      starClass: '',
      logoImg: '',

      goodsList: [],
      goodsList1: [],
      detailList: [],
      psCouponBos: [],

      id: 'wxopenLanchAppId',
      appid: 'wxbaafb4b97fb87904',
      wechatOpenAppData: '',
      json: {}
    }
  },
  created(){
    if(this.$route.query.activityId){
      this.itId = this.$route.query.itId
      this.itemType = this.$route.query.itemType
      this.activityId = this.$route.query.activityId
    } else {
      this.itId = this.$route.query.itId
      this.itemType = this.$route.query.itemType
    }
    this.json = {
      "type": "goods",
      "itId": this.itId,
      "itemType": this.itemType,
      "activityId": this.activityId,
    }
    this.wechatOpenAppData = JSON.stringify(this.json)
    if (this.itemType === '0') {
      this.shopgeneral() // 普通
    } else if (this.itemType === '1') {
      this.shopseckill() // 秒杀
    } else if (this.itemType === '2') {
      this.shoplimitBuy() // 品牌闪购
    } else if (this.itemType === '3') {
      this.shopnewGoods() // 新品首发
    } else if (this.itemType === '4') {
      this.shopcombination() // 联免组合
    }
    this.wxShare()
    if (iswx() === true) {
      let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      console.log('wechat',wechat)
      let judgewechat = wechat[1].split('.')
      if(judgewechat[0]>=7){
        if(judgewechat[1]>=0){
          if(judgewechat[2]>=12){
            this.openPopup = true
            console.log("当前符合 h5 打开指定app")                    
          }
        }
      }
    }
  },
  mounted() {
    if (this.openPopup == true) {
      var btn = document.getElementById(this.id)
      btn.addEventListener('launch', e => {
        // alert(JSON.stringify(this.wechatOpenAppData))
        console.log('success');
      });
      btn.addEventListener('error',  e => {
        this.text = e.detail.errMsg
        if (e.detail.errMsg == 'launch:fail') {
          window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer'
        } else {
          this.$createToast({
            txt: e.detail,
            type: 'error'
          }).show()
        }
      });
    }
  },
  methods: {
    // 下载APP跳转链接
    downloadapp() {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer'
    },
    // 关闭头部下载APP链接
    closeApp() {
      this.isApp = false;
    },
    // 普通
    async shopgeneral() {
      let data = {
        itId: this.itId,
      }
      const res = await shopGeneral(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.imgurl = res.data.data.generalInfo.pictureUrl
          this.retailPrice = res.data.data.generalInfo.retailPrice
          this.salesTotal = res.data.data.generalInfo.salesTotal
          this.bannerList = res.data.data.generalInfo.bannerList
          this.goodsName = res.data.data.generalInfo.goodsName
          this.commonName = res.data.data.generalInfo.commonName
          this.organId = res.data.data.generalInfo.organId
          this.detailList = res.data.data.generalInfo.detailList

          this.stName = res.data.data.store.stName
          this.starClass = res.data.data.store.starClass
          this.logoImg = res.data.data.store.logoImg
          this.shopenable(0)
          // console.log('this.bannerList=',this.bannerList)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 新品首发
    async shopnewGoods() {
      let data = {
        itId: this.itId,
        activityId: this.activityId,
      }
      const res = await shopNewGoods(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.imgurl = res.data.data.generalInfo.pictureUrl
          this.preferentialPrice = res.data.data.generalInfo.preferentialPrice
          this.retailPrice = res.data.data.generalInfo.retailPrice
          this.salesTotal = res.data.data.generalInfo.salesTotal
          this.bannerList = res.data.data.generalInfo.bannerList
          this.goodsName = res.data.data.generalInfo.goodsName
          this.commonName = res.data.data.generalInfo.commonName
          this.detailList = res.data.data.generalInfo.detailList

          this.stName = res.data.data.store.stName
          this.starClass = res.data.data.store.starClass
          this.logoImg = res.data.data.store.logoImg
          // console.log('this.bannerList=',this.bannerList)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 秒杀
    async shopseckill() {
      let data = {
        itId: this.itId,
        activityId: this.activityId,
      }
      const res = await shopSeckill(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.imgurl = res.data.data.generalInfo.pictureUrl
          this.activityEndTime = res.data.data.activityEndTime.substr(0,10)
          this.preferentialPrice = res.data.data.generalInfo.preferentialPrice
          this.retailPrice = res.data.data.generalInfo.retailPrice
          this.salesTotal = res.data.data.activityMaxNum - res.data.data.activityResidual
          this.bannerList = res.data.data.generalInfo.bannerList
          this.goodsName = res.data.data.activityTitle
          this.commonName = res.data.data.generalInfo.commonName
          this.detailList = res.data.data.generalInfo.detailList

          this.stName = res.data.data.store.stName
          this.starClass = res.data.data.store.starClass
          this.logoImg = res.data.data.store.logoImg
          // console.log('this.bannerList=',this.bannerList)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 品牌闪购
    async shoplimitBuy() {
      let data = {
        itId: this.itId,
        activityId: this.activityId,
      }
      const res = await shopLimitBuy(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.imgurl = res.data.data.generalInfo.pictureUrl
          this.activityEndTime = res.data.data.activityEndTime.substr(0,10)
          this.preferentialPrice = res.data.data.generalInfo.preferentialPrice
          this.retailPrice = res.data.data.generalInfo.retailPrice
          this.salesTotal = res.data.data.generalInfo.salesTotal
          this.bannerList = res.data.data.generalInfo.bannerList
          this.goodsName = res.data.data.generalInfo.goodsName
          this.commonName = res.data.data.generalInfo.commonName
          this.detailList = res.data.data.generalInfo.detailList

          this.stName = res.data.data.store.stName
          this.starClass = res.data.data.store.starClass
          this.logoImg = res.data.data.store.logoImg
          // console.log('this.bannerList=',this.bannerList)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 联免组合
    async shopcombination() {
      let data = {
        gpId: this.itId,
      }
      const res = await shopCombination(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.imgurl = res.data.data.baseInfo.gpShareImg
          this.activityEndTime = res.data.data.baseInfo.gpEndTime.substr(0,10)
          this.preferentialPrice = res.data.data.baseInfo.gpPrice
          this.retailPrice = res.data.data.baseInfo.gpRealPrice
          this.salesTotal = res.data.data.baseInfo.salesTotal
          this.bannerList = res.data.data.baseInfo.bannerList
          this.goodsName = res.data.data.baseInfo.gpTitle
          this.commonName = res.data.data.baseInfo.gpPackageDesc
          this.organId = res.data.data.baseInfo.organId
          this.detailList = res.data.data.baseInfo.detailList
          this.goodsList = res.data.data.baseInfo.goodsList
          
          this.shopenable(1)
          this.goodsList1 = result(this.goodsList)
          console.log('this.goodsList1=',this.goodsList1)
          if (res.data.data.store !== null) {
            this.stName = res.data.data.store.stName
            this.starClass = res.data.data.store.starClass
            this.logoImg = res.data.data.store.logoImg
          } else {
            this.store = false
            console.log('1111')
          }
          // this.scrollTo()
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 优惠券
    async shopenable(type) {
      let data = {
        type: type,
        itId: this.itId,
        organId: this.organId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      const res = await shopEnable(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.psCouponBos = res.data.data.psCouponBos
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    
    /*======= 微信分享 ======*/
    async wxShare() {
      // let shareUrl = encodeURIComponent(window.location.href.split('#')[0]);
      // console.log('shareUrl=',shareUrl)
      const res = await wxShare()
      try {
        let that = this
        that.shareUrl = window.location.href;
        console.log('shareUrl=',that.shareUrl)
        if (res.data.code == 200) {
          let shareUrl1 = that.shareUrl;
          console.log('shareUrl2=',shareUrl1)
          let appId = res.data.data.appid;
          let timestamp = res.data.data.timestamp;
          let nonceStr = res.data.data.noncestr;
          let signature = res.data.data.signature;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature,// 必填，签名，见附录1
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            openTagList: ['wx-open-launch-app']
          });
          wx.ready(function(){
            let imgurl = that.imgurl;
            let title = that.goodsName;
            let desc = that.desc;
            wx.error(function(res){ // config 信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的 debug 模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
                // alert("errorMSG:"+res.errMsg);
            });

            wx.onMenuShareTimeline({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: shareUrl1, // 分享链接
                imgUrl: imgurl, // 分享图标
                success: function () {
                  // 用户确认分享后执行的回调函数
                  this.$createToast({
                    type: 'correct',
                    txt: '分享成功',
                    time: 1000
                  }).show()
                },
                cancel: function () {
                  // 用户取消分享后执行的回调函数
                  this.$createToast({
                    txt: '分享失败',
                    type: 'error'
                  }).show()
                }
            });

            wx.onMenuShareAppMessage({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: shareUrl1, // 分享链接
                imgUrl: imgurl, // 分享图标
                success: function () {
                  // 用户确认分享后执行的回调函数
                  this.$createToast({
                    type: 'correct',
                    txt: '分享成功',
                    time: 1000
                  }).show()
                },
                cancel: function () {
                  // 用户取消分享后执行的回调函数
                  this.$createToast({
                    txt: '分享失败',
                    type: 'error'
                  }).show()
                }
            });

          });
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {
        console.log(error)
      }
    },

    // scrollTo() {
    //   this.$refs.scroll.scrollTo(
    //     0,
    //     this.scrollToY,
    //     this.scrollToTime,
    //     ease[this.scrollToEasing]
    //   )
    // },
    changePage(current) {
      console.log('当前轮播图序号为:' + current)
    },
    clickHandler(item, index) {
      console.log(item, index)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main {
  max-width: 768px;
  margin: 0 auto;
  .plk-app {
    width: 3.75rem;
    height: 0.45rem;
    display: flex;
    background: #ea4747;
    position: fixed;
    z-index: 9999;
    .plk-app-logo {
      flex: 0 0 0.4rem;
      margin-left: 0.1rem;
      align-self: center;
      height: 0.4rem;
      border-radius: 0.08rem;
      background: #fff;
      text-align: center;
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(234,71,71,1);
      line-height: 0.35rem;
      img {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.05rem
      }
    }
    .plk-app-title {
      flex: 1;
      align-self: center;
      text-align: left;
      margin-left: 0.1rem;
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(255,255,255,1);
      line-height: 0.18rem;
      span {
        display: block;
      }
      strong {
        display: block;
      }
    }
    .plk-app-right {
      flex: 0 0 1.3rem;
      align-self: center;
      display: flex;
      .plk-app-open {
        position: relative;
        flex: 0 0 1rem;
        height: 0.3rem;
        line-height: 0.3rem;
        background: rgba(255,255,255,1);
        border-radius: 0.14rem;
        .app-open {
          text-align: center;
          font-size:  0.14rem;
          font-weight: 400;
          color: rgba(234,71,71,1);
        }
        .launch-btn {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0;
        }
      }
      .plk-app-close {
        flex: 0 0 0.12rem;
        height: 0.3rem;
        line-height: 0.3rem;
        margin-left: 0.05rem;
        align-self: center;
        img {
          vertical-align: top;
          margin-top: 0.08rem;
          width: 0.14rem;
          height: 0.14rem;
        }
      }
    }
  }
  .plk-app-height {
    height: 0.46rem;
  }
  .plk-img-swiper {
    width: 100%;
    height: 3rem;
    overflow: hidden;
    .cube-slide-item {
      text-align: center;
      img {
        max-width: 100%;
        height: 3rem;
        object-fit: cover;
      }
    }
  }
  .plk-ordinary {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    .ordinary-left {
      flex: 1;
      align-self: center;
      text-align: left;
      font-size: 0.16rem;
      color: #EA4747;
    }
    .ordinary-right {
      flex: 0 0 1.2rem;
      align-self: center;
      text-align: right;
      font-size: 0.12rem;
      color: #9B9B9B;
    }
  }
  .plk-newgoods {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    background:linear-gradient(270deg,rgba(251,85,85,1) 0%,rgba(222,31,22,1) 100%);
    font-size: 0;
    .newgoods-img {
      flex: 0 0 0.34rem;
      align-self: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
    }
    .newgoods-left {
      flex: 1;
      margin-left: 0.1rem;
      align-self: center;
      text-align: left;
      strong {
        font-size: 0.16rem;
        color: #fff;
      }
      span {
        margin-left: 0.1rem;
        text-decoration: line-through;
        font-size: 0.1rem;
        color: #fff;
      }
    }
    .newgoods-right {
      flex: 0 0 1.2rem;
      align-self: center;
      text-align: right;
      font-size: 0.1rem;
      color: #fff;
    }
  }
  .plk-seckill {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    background:linear-gradient(270deg,rgba(251,85,85,1) 0%,rgba(222,31,22,1) 100%);
    font-size: 0;
    .seckill-img {
      flex: 0 0 0.34rem;
      align-self: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
    }
    .seckill-left {
      flex: 1;
      margin-left: 0.1rem;
      align-self: center;
      text-align: left;
      strong {
        font-size: 0.14rem;
        color: #fff;
      }
      .seckill-total {
        padding-top: 0.05rem;
        span {
          text-decoration: line-through;
          font-size: 0.1rem;
          color: #fff;
        }
        em {
          margin-left: 0.15rem;
          font-style: normal;;
          font-size: 0.1rem;
          color: #fff;
        }
      }
    }
    .seckill-right {
      flex: 0 0 1rem;
      align-self: center;
      .seckill-text {
        font-size: 0.1rem;
        color: #fff;
      }
      .seckill-time {
        padding-top: 0.05rem;
        font-size: 0.12rem;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  .plk-limitBuy {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    background:linear-gradient(270deg,rgba(255,50,43,1) 0%,rgba(144,19,254,1) 100%);
    font-size: 0;
    .limitBuy-img {
      flex: 0 0 0.34rem;
      align-self: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
    }
    .limitBuy-left {
      flex: 1;
      margin-left: 0.1rem;
      align-self: center;
      text-align: left;
      strong {
        font-size: 0.14rem;
        color: #fff;
      }
      .limitBuy-total {
        padding-top: 0.05rem;
        span {
          text-decoration: line-through;
          font-size: 0.1rem;
          color: #fff;
        }
        em {
          margin-left: 0.15rem;
          font-style: normal;;
          font-size: 0.1rem;
          color: #fff;
        }
      }
    }
    .limitBuy-right {
      flex: 0 0 1rem;
      align-self: center;
      .limitBuy-text {
        font-size: 0.1rem;
        color: #fff;
      }
      .limitBuy-time {
        padding-top: 0.05rem;
        font-size: 0.12rem;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  .plk-combination {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    background:linear-gradient(270deg,rgba(251,85,85,1) 0%,rgba(222,31,22,1) 100%);
    font-size: 0;
    .combination-img {
      flex: 0 0 0.34rem;
      align-self: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
    }
    .combination-left {
      flex: 1;
      margin-left: 0.1rem;
      align-self: center;
      text-align: left;
      strong {
        font-size: 0.14rem;
        color: #fff;
      }
      .combination-total {
        padding-top: 0.05rem;
        span {
          text-decoration: line-through;
          font-size: 0.1rem;
          color: #fff;
        }
        em {
          margin-left: 0.15rem;
          font-style: normal;;
          font-size: 0.1rem;
          color: #fff;
        }
      }
    }
    .combination-right {
      flex: 0 0 1rem;
      align-self: center;
      .combination-text {
        font-size: 0.1rem;
        color: #fff;
      }
      .combination-time {
        padding-top: 0.05rem;
        font-size: 0.12rem;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  .plk-title {
    padding: 0 0.1rem;
    text-align: left;
    font-size: 0;
    .plk-goodsName {
      padding: 0.1rem 0;
      font-size: 0.12rem;
      color: #000;
    }
    .plk-commonName {
      padding-bottom: 0.1rem;
      font-size: 0.12rem;
      color:rgba(155,155,155,1);
    }
  }
  .plk-goodslist {
    padding: 0.1rem;
    .goodslist-title {
      text-align: left;
      font-size: 0.14rem;
      font-weight: bold;
      color: #181818;
    }
    .goodslist {
      margin-top: 0.1rem;
      width: 3.5rem;
      height: 1.6rem;
      overflow: hidden;
      text-align: left;
      .goodslist-box {
        display: inline-block;
        width: 1.1rem;
        margin-right: 0.1rem;
        .goodslist-img {
          width: 1.1rem;
          height: 1.1rem;
          border: 0.01rem solid #F1F1F1;
          img {
            width: 1.1rem;
            height: 1.1rem;
          }
        }
        .goodslist-text {
          padding: 0.05rem 0;
          text-align: center;
          font-size: 0.12rem;
          color: #000;
        }
        .goodslist-pices {
          text-align: center;
          font-size: 0.12rem;
          color: #EA4747;
        }
      }
    }
  }
  .plk-securities {
    display: flex;
    height: 0.5rem;
    background: #fff;
    .plk-securities-left {
      flex: 0 0 0.4rem;
      font-size: 0.1rem;
      font-weight: bold;
      align-self: center;
      color: #181818;
    }
    .plk-securities-right {
      flex: 1;
      align-self: center;
      text-align: left;
      font-size: 0;
      .securities {
        display: inline-block;
        margin-right: 0.05rem;
        padding: 0 0.1rem;
        width: 0.78rem;
        height: 0.4rem;
        background: url(../assets/img/juan@2x.png) no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 0.4rem;
        font-size: 0.1rem;
        color: #EA4747;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }
  .plk-back {
    padding: 0.1rem 0;
    background: #F7F7F7;
  }
  .plk-back-bottom {
    padding-bottom: 0.1rem;
    background: #F7F7F7;
  }
  .plk-back-top {
    padding-top: 0.1rem;
    background: #F7F7F7;
  }
  .plk-statement {
    display: flex;
    padding: 0.14rem 0.1rem;
    background: #fff;
    font-size: 0;
    text-align: left;
    .plk-zpbz {
      flex: 0 0 1rem;
      vertical-align: middle;
      img {
        width: 0.18rem;
        height: 0.18rem;
        vertical-align: middle;
      }
      span {
        margin-left: 0.05rem;
        vertical-align: middle;
        font-size: 0.1rem;
        color: #181818;
      }
    }
    .plk-jyps {
      flex: 0 0 1rem;
      vertical-align: middle;
      img {
        width: 0.18rem;
        height: 0.18rem;
        vertical-align: middle;
      }
      span {
        margin-left: 0.05rem;
        vertical-align: middle;
        font-size: 0.1rem;
        color: #181818;
      }
    }
  }
  .plk-store {
    display: flex;
    padding: 0.1rem;
    background: #fff;
    font-size: 0;
    .store-logoImg {
      flex: 0 0 0.48rem;
      img {
        width: 0.48rem;
        height: 0.48rem;
      }
    }
    .store-text {
      flex: 1;
      position: relative;
      margin-left: 0.05rem;
      .store-name {
        text-align: left;
        font-size: 0.14rem;
        color: #181818;
      }
      .store-start {
        position: absolute;
        left: 0;
        bottom: 0;
        text-align: left;
        .start {
          font-size: 0.12rem;
          color: #EA4747;
          span {
            margin-right: 0.05rem;
            color: #818181;
          }
        }
      }
    }
  }
  .plk-detail {
    font-size: 0;
    text-align: center;
    .detail-title {
      display: inline-block;
      padding: 0.1rem 0 0.05rem;
      font-size: 0.14rem;
      color: #181818;
      border-bottom: 2px solid rgba(223,38,38,1);
    }
    .detail-img {
      padding-top: 0.1rem;
      img {
        width: 100%;
      }
    }
  }
  .plk-height {
    height: 0.45rem;
  }
  .plk-buton {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .plk-float-buton {
    width: 3.75rem;
    height: 0.45rem;
    margin: 0 auto;
    background: rgba(234,71,71,1);
    text-align: center;
    font-size: 0.14rem;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: rgba(255,255,255,1);
    line-height: 0.45rem;
  }
}
</style>